import React, { useEffect } from "react";
import styles from "./GoogleRecapcha.module.scss";
import { AppSettings } from "application/index";

import ReCAPTCHA from "react-google-recaptcha";

const GoogleRecaptcha = React.forwardRef((props, ref) => {
  const {
    className = styles.recatcha,
    size = "invisible",
    siteKey = AppSettings.recatchaKey,
    onChange,
    ...other
  } = props;



  useEffect(() => {
    const onSubmitWithReCAPTCHA = async () => {
      const token = await ref.current.executeAsync();
      onChange(token);
      // apply to form data
    }
    onSubmitWithReCAPTCHA();
  }, [ref, onChange])


  return (
    <div>
      <ReCAPTCHA
        ref={ref}
        className={className}
        size={size}
        sitekey={siteKey}
        hl="es"
        badge="bottomright"
        {...other}
      />
    </div>
  );
});

export default GoogleRecaptcha;
